import { IModuleConfigOptions } from "./IModuleConfigOptions";
import { modules } from "../../../main";

export function ModuleConfig( options:IModuleConfigOptions ){
    return (module:any) => {
        if ( typeof options.style !== "undefined" ){
            modules.importModuleStyle( options.moduleName, options.style );
        }
    }
}